import React, { useState, useEffect } from "react";
import { Skeleton } from "@mui/material";
import Axios from "axios";
import Cards from "./FundCompaniesCard/Cards";

const SkeletonCard = () => (
  <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "18px 20px" }}>
    <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
      <Skeleton variant="rectangular" width={52} height={52} style={{ borderRadius: 8, flexShrink: 0 }} />
      <div style={{ flex: 1 }}>
        <Skeleton variant="text" width="60%" height={18} />
        <Skeleton variant="text" width="35%" height={14} style={{ marginTop: 4 }} />
      </div>
    </div>
    <div style={{ display: "flex", gap: 6, marginBottom: 14 }}>
      <Skeleton variant="rectangular" width={100} height={24} style={{ borderRadius: 20 }} />
      <Skeleton variant="rectangular" width={80} height={24} style={{ borderRadius: 20 }} />
    </div>
    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <Skeleton variant="rectangular" width={90} height={34} style={{ borderRadius: 8 }} />
    </div>
  </div>
);

const NonVerifyFundCompanies = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    Axios({ method: "GET", url: "/api/admin/handle-fc" })
      .then((res) => setData(res.data.nonverified))
      .catch(() => setData([]));
  }, []);

  return (
    <div style={{ padding: "36px 40px", maxWidth: 1200, margin: "0 auto", boxSizing: "border-box" }}>
      <div style={{ marginBottom: 32 }}>
        <h1 style={{ fontFamily: "Nunito", fontWeight: 800, fontSize: 40, color: "#111827", margin: 0 }}>
          Fund Requests
        </h1>
        <p style={{ fontFamily: "Nunito", fontSize: 14, color: "#6b7280", margin: "6px 0 0" }}>
          {data === null
            ? "Loading…"
            : `${data.length} pending verification${data.length !== 1 ? "s" : ""}`}
        </p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 16 }}>
        {data === null
          ? Array(8).fill(0).map((_, i) => <SkeletonCard key={i} />)
          : data.length === 0
            ? <p style={{ fontFamily: "Nunito", color: "#9ca3af", fontSize: 15, gridColumn: "1/-1" }}>No pending verifications.</p>
            : data.map((item, i) => <Cards key={item._id || i} data={item} />)}
      </div>
    </div>
  );
};

export default NonVerifyFundCompanies;
